import {SActionBtn, SAlert, SBack, SLowcodeList,STableActions, STags} from "shj-components";
import {config} from "./config.tsx";
import {useSearchParams} from "react-router-dom";
import {
  getAuthGeneralStandardPage,
  getBrandList,
} from "@/services/product.ts";
import {apiData2Table} from "@/utils/data.ts";
import React, {useEffect, useRef, useState} from "react";
import styles from "@/pages/baseProduct/schemeProductList/index.module.less";
import {getAllCompany} from "@/services/homeService.ts";
import CombinationDetails from "@/pages/baseProduct/schemeProductList/components/CombinationDetails";
import { isArray } from 'lodash-es'

const StandardConfigDetails = () => {
  const [searchParams] = useSearchParams({})
  const id = searchParams.get('busId')
  const listId = searchParams.get('listId')
  const nodeName = searchParams.get('nodeName')
  const companyId = searchParams.get('companyId'); // 获取参数值
  const listRef = useRef();
  const [currentRecord, setCurrentRecord] = useState<any>({});
  const [isCombinationDetails, setIsCombinationDetails] = useState(false);
  useEffect(() => {
    if(companyId){
      reloadFn(companyId)
    }
  },[companyId])

  const reloadFn = (companyId)=>{
    listRef?.current?.getSearch()?.setFieldValue('orgId',companyId);
    listRef?.current?.reloadAndSearch();
  }
  const fetchList = ({current, pageSize, query}) => {
    if(!id)return ;
    return new Promise((resolve, reject) => {
      const data = {
        genItemId:id,
        applyProdIdList:listId?["0",listId]:["0"],
        "orderBys": [
          {
            "columnName": "id",
            "asc": false
          }
        ],
        "searchFlag": true,
        ...query,
      }
      console.log(data)
      data.orgIdList =data?.orgId? ["0",data?.orgId||""]:[];
      delete data.orgId;
      getAuthGeneralStandardPage({
        params: {pageId: current, pageSize},
        data
      }).then(res => {
        res.list =isArray(res?.list)?res?.list?.map((item, index) => {
          return {
            ...item,
            orderNumber: index + 1,
          }
        }):[]
        resolve(apiData2Table(res))
      }).catch(reject)
    })
  }
  const onDetail = (obj) => {
    const searchOrgId = listRef?.current?.getSearch()?.getFieldValue('orgId');
    setIsCombinationDetails(true)
    setCurrentRecord({
      id:obj?.productSku?.productId||"",
      companyId:obj?.orgId,
      searchOrgId:searchOrgId||""
    });
  }

  //   下拉选项加载
  const getOptions = async () => {
    return new Promise(resolve => {
      Promise.all([
        getBrandList({}),
        getAllCompany(),
      ]).then((res: any) => {
        const obj = {
          brandList: res[0]?.map((item: any) => {
            return { label: item.name, value: item.id }
          }),
          companyList: res[1],
        }
        resolve({ ...obj })
      })
    })
  }
  const onSearchReset = () => {
    reloadFn(companyId)
  }

  const extensions = {
    onSearchReset,
    request: {fetchList, getOptions},
    customRender: {
      enableRender(_, record: Record<string, any>) {
        if(!record?.productSku){
          return <></>
        }else {
          const enabled = record?.productSku?.enabled;
          return (
              <STags itemKey='' label={enabled ? '启用' : '禁用'} fontColor={enabled ? '#00A865' : '#EB3723'} bgColor={enabled ? '#D7F7EA' : '#FFEAE8'} />
          )
        }
      },
      actionRender(_: null, record: Record<string, any>) {
        if(record?.productSku&&record?.productSku?.prodType==='PRODUCT_GROUP'){
          return (
              <STableActions>
                <SActionBtn onClick={() => onDetail(record)}>组合详情</SActionBtn>
              </STableActions>
          )
        }
      }
    }
  }
  const rowClassName = (record) => {
    const searchOrgId = listRef?.current?.getSearch()?.getFieldValue('orgId');
    const orgId = record?.orgId;
    const shopIds = record?.productSku?.shopIds || [];
    //异常情况 不含通用，不包含所选门店，类型为产品，sku被删
    if(!record?.productSku||(!shopIds.includes("0")&&!shopIds.includes(orgId)&&!shopIds.includes(searchOrgId))){
      return 'rowBgColor';
    }
    return "";
  };

  return (
    <SBack level={3} title={`${decodeURIComponent(nodeName || '')}-标配情况`}>
      <div className={styles.container}>
        <div className={styles.topBox}>
          <SAlert type="info">
            <span className={'rowBgColor'}>红色字体行</span>
            表示该产品SKU数据异常：打包有配置查询门店可用，但产品SKU在供应链侧该门店可能已经缺断货或下架，需要联系总部打包人员处理
          </SAlert>
        </div>
        <div className={styles.content}>
          <SLowcodeList
            searchMode={'group'}
            ref={listRef}
            config={{
              ...config,
              searchInitialValues:{
                orgId:companyId,
              }
            }}
            {...extensions}
            rowClassName={rowClassName}
          />
        </div>
        {/*组合详情*/}
        {isCombinationDetails ? (
          <CombinationDetails
            open={isCombinationDetails}
            record={currentRecord}
            onClose={() => {
              setIsCombinationDetails(false)
              setCurrentRecord({})
            }}
          />
        ) : null}
      </div>
    </SBack>
  )
};

export default StandardConfigDetails;
